/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import { PAGE_TITLE } from '../../Configuration'
import Feedback from '../../components/feedback/feedback'
import usePageTitle from '../../hooks/use-page-title'
import PageHeader from '../../layouts/header/page-header'

const SiteFeedback = () => {
  usePageTitle(PAGE_TITLE.SITE_FEEDBACK)
  return (
    <div className='d-flex w-100 h-100 align-items-center justify-content-center flex-column'>
      <PageHeader
        icon='icon-feedback font-14 me-1 color-primary'
        name='Site Feedback'
      />

      <div className='container containerheight d-flex justify-content-center align-items-center'>
        <Feedback />
      </div>

    </div>
  )
}
export default SiteFeedback
